/**
 * organic-v2 look — mirrors the app's 4.33 UI refresh (constants/theme.ts,
 * app/(onboarding)/onboarding.tsx). The app palette is Tailwind's slate scale,
 * so the classes below map 1:1:
 *   text #1E293B = slate-800 · textSecondary #64748B = slate-500 ·
 *   textMuted #94A3B8 = slate-400 · border #E2E8F0 = slate-200 ·
 *   surfaceInner #F1F5F9 = slate-100 · background #FAFBFC
 * Option cards: radius 12, 2px border, selected = primary border + primary at
 * ~8% (`${primary}15`), label weight 600 in the normal text colour, 32px mark.
 * Only rendered for the organic-v2 arm; control markup is untouched.
 */
export const V2 = {
  page: 'bg-[#FAFBFC]',
  text: 'text-slate-800',
  textSecondary: 'text-slate-500',
  textMuted: 'text-slate-400',
  border: 'border-slate-200',
  selectedBg: 'bg-primary/[0.08]',
  h1: 'text-[32px] leading-10 font-bold tracking-[-0.5px] text-slate-800',
} as const

/** Public path of an organic-v2 illustrated icon (public/images/v2, built by scripts/build-v2-icons.sh). */
export function v2Icon(name: string): string {
  return `/images/v2/${name}.webp`
}
